"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAxios = getAxios;
var _axios = require("@ori/axios");
var _axiosRetry = _interopRequireDefault(require("axios-retry"));
const RETRIES_COUNT = 3;
const TIMEOUT = 3000;
const ACCEPT_ENCODING_HEADER = 'Accept-Encoding';
const ACCEPTED_ENCODING = 'gzip, deflate, br';
const axiosClients = {};
function getAxios(configurationStorageUrl) {
  if (!configurationStorageUrl) {
    throw new Error('Creating axios instance for Configuration Manager without passing the base url of a configuration storage');
  }
  const axiosClient = axiosClients[configurationStorageUrl];
  if (axiosClient) {
    return axiosClient;
  }
  const headers = {
    [ACCEPT_ENCODING_HEADER]: ACCEPTED_ENCODING
  };
  const axiosInstance = _axios.axios.create({
    timeout: TIMEOUT,
    baseURL: configurationStorageUrl,
    headers,
    transitional: {
      clarifyTimeoutError: true
    }
  });
  (0, _axiosRetry.default)(axiosInstance, {
    retries: RETRIES_COUNT,
    shouldResetTimeout: true
  });
  axiosClients[configurationStorageUrl] = axiosInstance;
  return axiosInstance;
}
//# sourceMappingURL=getAxios.js.map